var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.84615 2C3.73079 2 2 3.73079 2 5.84615V18.1538C2 20.2692 3.73079 22 5.84615 22H18.1538C20.2692 22 22 20.2692 22 18.1538V5.84615C22 3.73079 20.2692 2 18.1538 2H5.84615ZM5.84615 3.53846H18.1538C19.4385 3.53846 20.4615 4.56152 20.4615 5.84615V18.1538C20.4615 19.4385 19.4385 20.4615 18.1538 20.4615H15.6989V14.2566H17.8474L18.1689 11.7806H15.6989V10.2031C15.6989 9.4862 15.8985 8.9982 16.9339 8.9982H18.256V6.78365C18.0268 6.75288 17.2422 6.6875 16.3299 6.6875C14.4253 6.6875 13.1238 7.83981 13.1238 9.95673V11.7806L11.2308 11.7746V14.2506L13.1238 14.2566V20.4615H5.84615C4.56152 20.4615 3.53846 19.4385 3.53846 18.1538V5.84615C3.53846 4.56152 4.56152 3.53846 5.84615 3.53846Z","fill":"black"}));
}

Facebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
